/**
 * Build a compact page list with ellipsis for large page counts.
 * Example (page 12 of 25): [1, '…', 11, 12, 13, '…', 25]
 */
export function getVisiblePages(currentPage, totalPages, siblingCount = 1) {
  if (totalPages <= 1) return [];
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const pages = new Set();
  pages.add(1);
  pages.add(totalPages);

  const start = Math.max(2, currentPage - siblingCount);
  const end = Math.min(totalPages - 1, currentPage + siblingCount);
  for (let i = start; i <= end; i += 1) {
    pages.add(i);
  }

  // Keep a bit more context near the edges so we don't show awkward gaps
  if (currentPage <= siblingCount + 2) {
    for (let i = 2; i <= Math.min(3 + siblingCount * 2, totalPages - 1); i += 1) {
      pages.add(i);
    }
  }
  if (currentPage >= totalPages - siblingCount - 1) {
    for (let i = Math.max(2, totalPages - 2 - siblingCount * 2); i <= totalPages - 1; i += 1) {
      pages.add(i);
    }
  }

  const sorted = [...pages].sort((a, b) => a - b);
  const result = [];
  for (let i = 0; i < sorted.length; i += 1) {
    if (i > 0 && sorted[i] - sorted[i - 1] > 1) {
      result.push('…');
    }
    result.push(sorted[i]);
  }
  return result;
}
